import SpreedlyCheckoutSdkCard from 'components/payment/spreedly-checkout-sdk/spreedly-card/spreedly-checkout-sdk-card.component';
import * as S from './spreedly-card-guest.styles';

const SpreedlyCardGuest = () => {
  return (
    <S.Container>
      <SpreedlyCheckoutSdkCard />
    </S.Container>
  );
};

export default SpreedlyCardGuest;
